import UNIFORM_TYPE from './uniformTypes';
import defaultVertexShader   from './shaders/default-vs.glsl';
import defaultFragmentShader from './shaders/default-fs.glsl';
import uuid from './utils/uuid';

const settings = {
  compareUniforms:   false,
  compareAttributes: false,
}

const IS_SAFARI = /Safari/g.test(navigator.userAgent) && !/Chrome/g.test(navigator.userAgent)

const TEXTURE_2D = 35678
const TEXTURE_CUBE_MAP = 35680;

let currentBindedUniforms = {}
let currentBindedSamplers = {}
let angle_instanced_array;
let currentState = {
  attributes: [],
  uniforms: {},
  depthTest:  null,
  blend: false,
  program: null,
  geometry: null
}


var _lastUsedDepthTest = null
var _lastUsedGeometry  = null


function addLineNumbers( string ) {
  var lines = string.split( '\n' );
  for ( var i = 0; i < lines.length; i ++ ) {
      lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];
  }
  return lines.join( '\n' );
}

function compileShader( gl, shader, code ){
  gl.shaderSource( shader, code );
  gl.compileShader( shader );
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    console.error('Shader cannot compile: \n' + gl.getShaderInfoLog(shader) || "" );
    console.warn(addLineNumbers(code));
    return false;
  }
  return true;
}

function equal(arr1, arr2) {
  var length = arr1.length
  // if (arr1 === arr2) return true
  if (length !== arr2.length) return false
  for (var i = 0; i < length; i++)
    if (arr1[i] !== arr2[i])
      return false
  return true
}


class Program {

  constructor(gl, options={}) {

    this._uuid = uuid();

    if (!gl) {
      return;
    }

    options = Object.assign({}, {
      vertexShader:   defaultVertexShader,
      fragmentShader: defaultFragmentShader,
      defines:    {},
      extentions: {},
      type: gl.TRIANGLES,
      uniforms: {},
    }, options);

    this.options = options;
    
    this._vertexShaderSource   = options.vertexShader;
    this._fragmentShaderSource = options.fragmentShader;

    this.gl             = gl;
    this._program       = gl.createProgram();
    this.vertexShader   = gl.createShader( gl.VERTEX_SHADER );
    this.fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );

    gl.attachShader(this._program, this.vertexShader);
    gl.attachShader(this._program, this.fragmentShader);
    
    this.type          = options.type;
    this.attributes    = {};
    this.defines       = options.defines;
    this._lastDefines       = {};
    this.extentions    = options.extentions;

    this._textureUnit  = 0;

    this.depthTest     = options.depthTest     !== void 0 ? options.depthTest : true;
    this.blend         = options.blend         !== void 0 ? options.blend : false;
    this.blendEquation = options.blendEquation !== void 0 ? options.blendEquation : this.gl.FUNC_ADD;
    this.blendSrc   = options.blendSrc   !== void 0 ? options.blendSrc   : this.gl.SRC_ALPHA;
    this.blendDst   = options.blendDst   !== void 0 ? options.blendDst   : this.gl.ONE_MINUS_SRC_ALPHA;
    this.blendSrcRGB   = options.blendSrcRGB   !== void 0 ? options.blendSrcRGB   : this.gl.SRC_ALPHA;
    this.blendDstRGB   = options.blendDstRGB   !== void 0 ? options.blendDstRGB   : this.gl.ONE_MINUS_SRC_ALPHA;
    this.blendSrcAlpha = options.blendSrcAlpha !== void 0 ? options.blendSrcAlpha : this.gl.ONE;
    this.blendDstAlpha = options.blendDstAlpha !== void 0 ? options.blendDstAlpha : this.gl.ONE_MINUS_SRC_ALPHA;

    this.wireframe     = options.wireframe !== void 0 ? options.wireframe : false;

    this.uniforms = {};

    this.defaultUniforms = options.uniforms;
    this.compile();

  }

  compile() {

    if (!this.gl) {
      return;
    }
    
    if (this.isCompiling) {
      return;
    }

    // console.log('compile shader')
    
    this.isCompiling = true;

    var defines = '';
    for (var d in this.defines) {
      if (this.defines[d] !== null) {
        defines += '#define '+d+' '+this.defines[d]+'\n';
      }
    }

    //fix: this forces Safari to update ACTIVE_UNIFORMS after first compile()
    if (IS_SAFARI) {
      this.gl.detachShader(this._program, this.vertexShader);
      this.gl.detachShader(this._program, this.fragmentShader);
      this.vertexShader   = this.gl.createShader( this.gl.VERTEX_SHADER );
      this.fragmentShader = this.gl.createShader( this.gl.FRAGMENT_SHADER );
      this.gl.attachShader(this._program, this.vertexShader);
      this.gl.attachShader(this._program, this.fragmentShader);
    }
    

    if( !( compileShader( this.gl, this.vertexShader,   defines + this._vertexShaderSource ) &&
           compileShader( this.gl, this.fragmentShader, defines + this._fragmentShaderSource ) ) ) {
      console.warn('compile error')
      return false;
    }

    this.gl.linkProgram(this._program);

    if (!this.gl.getProgramParameter(this._program, this.gl.LINK_STATUS)) {
      console.error("Cannot link program: \n" + this.gl.getProgramInfoLog(this._program) || "");
      console.warn("VERTEX_SHADER:\n"+addLineNumbers(this._vertexShaderSource)
                  +"\n\nFRAGMENT_SHADER:\n"+addLineNumbers(this._fragmentShaderSource));
    }

    this.gl.useProgram(this._program);

    this._retrieveUniformsFromShader();

  }

  _retrieveUniformsFromShader() {



//debug
let isMMatrix = false;

    /**
     * When re-compiling, we dont wanna loose current uniform values
     * another appoch would be to set uniforms on Program instead of tagrte uniform.value:
     * program.uniform[uniformName]
     *   instead of 
     *  program.uniforms[uniformName].value
     */
    this._savedUniforms = {};
    for (let k in this.uniforms) {
      this._savedUniforms[k] = {
        value: this.uniforms[k].value
      }
    }

    this.uniforms      = {};
    this._textureUnit = 0;

    var numUniforms = this.gl.getProgramParameter( this._program, this.gl.ACTIVE_UNIFORMS );

    for (let i = 0; i < numUniforms; ++i) {
      
      var uniform = this.gl.getActiveUniform( this._program, i );

      if( uniform === null ){
        this.gl.getError();
        continue;
      }

      let name = uniform.name;

      let isArray = false;//is uniform array  ?(ex: 3fv, 4fv...)

      // tltr; we want 'myUniform[0]' to become 'myUniform'
      // if array uniform, replace the retrieved name as it includes the first index acces
      if (/\[.*\]/.test(name) ) {
        isArray = true;
        name = name.replace(/\[.*\]/,'');
      }

      if (this.uniforms[ name ] !== void 0) {
        this.uniforms[ name ].location = this.gl.getUniformLocation( this._program, name );
        this.uniforms[ name ].type = uniform.type;

      }
      else {

        this.uniforms[ name ] = {
          isArray: isArray,
          location: this.gl.getUniformLocation( this._program, name ),
          type: uniform.type,
          value: null,
          oldValue: null,
          size: uniform.size
        }
      
        //set texture unit
        if (uniform.type === TEXTURE_2D || uniform.type === TEXTURE_CUBE_MAP) {
          this.uniforms[ name ].unit = this._textureUnit;
          this._textureUnit++;
        }
      
      }

    }


    let isEnd = false;
    //merge user defined uniforms
    for (let u in this._savedUniforms) {
        if (this.uniforms[u] !== void 0){ 
          if (this._savedUniforms[u].value !== void 0 
              && this._savedUniforms[u].value !== null) {
            this.uniforms[u].value = this._savedUniforms[u].value;
          }
        }
    }

    /**
     * Restore unfiroms values set on Program creation by user
     */
    for (let u in this.defaultUniforms) {
      if (this.uniforms[u] !== void 0 
        && this.defaultUniforms[u] !== void 0 
          && this.defaultUniforms[u] !== null) {
          this.uniforms[u].value = this.defaultUniforms[u];
      }
    }

    var numAttributes = this.gl.getProgramParameter( this._program, this.gl.ACTIVE_ATTRIBUTES );

    for (let i = 0; i < numAttributes; ++i) {
      
      var attribute = this.gl.getActiveAttrib( this._program, i );
        
      if( attribute === null ){
        this.gl.getError();
        continue;
      } 

      this.attributes[ attribute.name ] = {
        location: this.gl.getAttribLocation( this._program, attribute.name ),
        type: attribute.type
      }

      //the attribute is only enabled when the buffer is binded
      //(so it's enabled by the Program that will use the buffer)
      //this way we make sure that any enabled attribute has some data not to trigger an error
      //see https://www.mjbshaw.com/2013/03/webgl-fixing-invalidoperation.html
      // this.gl.enableVertexAttribArray( this.attributes[attribute.name].location );
    
    }

    this.isCompiling = false;


  }

  dispose() {

  }

  use () {
    if (!this.gl) {
      return;
    }
    

    this.gl.useProgram(this._program);
  }

  attribPointer(geometry) {

    if (!this.gl) {
      return;
    }
    
    angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );

    for (var attr in this.attributes) {
      if (geometry.attributes[attr] !== void 0) {

        if (attr == 'instanceMatrix') {

          if (!currentState.attributes[ this.attributes[attr].location ]
              || currentState.attributes[ this.attributes[attr].location ].buffer != geometry.attributes[attr]
              || !settings.compareAttributes
              ) {
              const bytesPerMatrix = 4 * 16;
              for (let i = 0; i < 4; ++i) {
                const loc = this.attributes[attr].location + i;
                geometry.attributes[attr].bind();
                this.gl.enableVertexAttribArray(loc);
                // if ( !currentState.attributes[ this.attributes[attr].location ] 
                //     ||  !currentState.attributes[ this.attributes[attr].location ].divisor 
                // || settings.compareAttributes
                // ) {
                  angle_instanced_array.vertexAttribDivisorANGLE(loc, 1);
                // }
                const offset = i * 16;  // 4 floats per row, 4 bytes per float
                this.gl.vertexAttribPointer(
                    loc,              // location
                    4,                // size (num values to pull from buffer per iteration)
                    geometry.attributes[attr].type,         // type of data in buffer
                    false,            // normalize
                    bytesPerMatrix,   // stride, num bytes to advance to get to next set of values
                    offset,           // offset in buffer
                );
                currentState.attributes[ loc ] = {divisor: true, name: 'instanceMatrix', buffer: geometry.attributes[attr] }
              }
          }
        }
        else 
        {

          if (   !currentState.attributes[ this.attributes[attr].location ]
              || currentState.attributes[ this.attributes[attr].location ].buffer != geometry.attributes[attr]
              || !settings.compareAttributes
          ){
            if ( currentState.attributes[ this.attributes[attr].location ]
                 && currentState.attributes[ this.attributes[attr].location ].divisor  ) {
              angle_instanced_array.vertexAttribDivisorANGLE( this.attributes[attr].location, 0 );
            }
            if (!currentState.attributes[ this.attributes[attr].location ]
                || !settings.compareAttributes) {
              this.gl.enableVertexAttribArray(  this.attributes[attr].location );
            }
            geometry.attributes[attr].bind();
            this.gl.vertexAttribPointer( this.attributes[attr].location, geometry.attributes[attr].size, geometry.attributes[attr].type, false/*normalized*/, 0, 0);
            currentState.attributes[ this.attributes[attr].location ] = {divisor: false, name: attr, buffer: geometry.attributes[attr]}
            }

        }
      }
    }
  }



  draw(geometry) {

    if (!this.gl) {
      return;
    }

    
    let definesL = Object.keys(this.defines)
    let lastDefinesL = Object.keys(this._lastDefines)
    let needsCompile = definesL.length != lastDefinesL.length

    for (var d in this.defines) {
      if (this.defines[d] != this._lastDefines[d]) {
        needsCompile = true;
      }
    }

    if (needsCompile) { 
      this._lastDefines = {}
      for (var d in this.defines) {
        this._lastDefines[d] = this.defines[d] 
      }
      this.compile()
    }
    
    let isNewProgram = false
    if (needsCompile || this._program !== currentState.program) {
      isNewProgram = true
      currentBindedUniforms = {}
      currentBindedSamplers = {}
      this.gl.useProgram(this._program);
      currentState.program = this._program;
    }
    
    //!!! WARNING  THIS OPTIM BREAKS SKY ADN OTHER THINGS ON WINDOWS !!!
    // if (geometry !== _lastUsedGeometry) {
      //TODO: check if geometry has changed
      this.attribPointer(geometry);
      _lastUsedGeometry  = geometry;
    // }

    if (this.depthTest !== currentState.depthTest) {
      this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
      currentState.depthTest = this.depthTest;
    }
    if (this.blend) {
      // this.gl.disable(this.gl.DEPTH_TEST);
      // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
      if (this.depthTest) {
        this.gl.depthFunc( this.gl.LESS );
      }
      
      if (currentState.blendEquation !== this.blendEquation) {
        this.gl.blendEquation(this.blendEquation);
        currentState.blendEquation = this.blendEquation
      }

      if (currentState.blendSrcRGB !== this.blendSrcRGB
        || currentState.blendDstRGB !== this.blendDstRGB
        || currentState.blendSrcAlpha !== this.blendSrcAlpha
        || currentState.blendDstAlpha !== this.blendDstAlpha) {
        currentState.blendSrcRGB = this.blendSrcRGB
        currentState.blendDstRGB = this.blendDstRGB
        currentState.blendSrcAlpha = this.blendSrcAlpha
        currentState.blendDstAlpha = this.blendDstAlpha
        this.gl.blendFuncSeparate(this.blendSrcRGB, this.blendDstRGB, this.blendSrcAlpha, this.blendDstAlpha);
      }
      
      // this.gl.blendFunc(this.blendSrc,this.blendDst);
      if (!currentState.blend) {
        this.gl.enable(this.gl.BLEND);
        currentState.blend = true;
      }
    }
    else {
      if (currentState.blend) {
        this.gl.disable(this.gl.BLEND);
        currentState.blend = false;
      }
      // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
      if (this.depthTest) {
        this.gl.depthFunc( this.gl.LESS );
      }
    }

    var keys = Object.keys(this.uniforms);

    for (var i=0,l=keys.length; i<l; i++) 
    {
      let uniformName = keys[i];
      if ( 
           this.uniforms[ uniformName ].value !== null
        && this.uniforms[ uniformName ].value !== void 0
        ){
          switch (this.uniforms[ uniformName ].type) {

            case this.gl.FLOAT_MAT2:
            case this.gl.FLOAT_MAT3:
            case this.gl.FLOAT_MAT4:
    
                let needChange = true; 
                if (settings.compareUniforms) {
                  if (this.uniforms[ uniformName ].oldValue !== null && !isNewProgram) {
                    needChange = false
                    let array1 = this.uniforms[ uniformName ].value;
                    let array2 = this.uniforms[ uniformName ].oldValue;
                    if (array1.length !== array2.length) {
                      needChange = true
                    }
                    else {
                      for (var j = 0; j < array1.length; j++) {
                        if (array1[j] !== array2[j]) {
                          needChange = true
                          break
                        }
                      }
                    }
                  }
                  else {
                    needChange = true 
                  }
                }

                if (needChange) {
                  this.gl['uniform' + UNIFORM_TYPE[this.uniforms[ uniformName ].type]+'v'](this.uniforms[ uniformName ].location, false, this.uniforms[ uniformName ].value);
                  this.uniforms[ uniformName ].oldValue = this.uniforms[ uniformName ].value
                  currentState.uniforms[ uniformName ] = this.uniforms[ uniformName ].value
                }
              break;
            default:
              
              //texture2D
              if (this.uniforms[ uniformName ].type === TEXTURE_2D ||
                  this.uniforms[ uniformName ].type === TEXTURE_CUBE_MAP ){
                  let needChange = true;
                  if (settings.compareUniforms) {
                    if (currentBindedSamplers[ this.uniforms[ uniformName ].unit ] != void 0 &&
                        currentBindedSamplers[ this.uniforms[ uniformName ].unit ] !== null && 
                        !isNewProgram) {
                        needChange = false;
                      if (currentBindedSamplers[ this.uniforms[ uniformName ].unit ] !== this.uniforms[ uniformName ].value) {
                        needChange = true
                      }
                      currentBindedSamplers[ this.uniforms[ uniformName ].unit ] = this.uniforms[ uniformName ].value
                    }
                    else {
                      needChange = true;
                    }
                  }
                  if (needChange) {
                    this.uniforms[ uniformName ].value.bind( this.uniforms[ uniformName ].unit );
                    this.gl['uniform' + UNIFORM_TYPE[this.uniforms[ uniformName ].type] ](this.uniforms[ uniformName ].location, this.uniforms[ uniformName ].unit);
                  }
              }
              else {
    
                let type = UNIFORM_TYPE[this.uniforms[ keys[i] ].type];
                
                //add 'v' to the uniformType if the unifor is an array: ex "3f" => "3fv"
                if (this.uniforms[ uniformName ].isArray) {
                  type += 'v';
                }
    
                let needChange = true;

                if (settings.compareUniforms) {
                  if (currentBindedUniforms[ uniformName ] != void 0 &&
                      currentBindedUniforms[ uniformName ] !== null && 
                      !isNewProgram) {
                        needChange = false;
                      if ( typeof currentBindedUniforms[ uniformName ] == 'number') {
                        if (currentBindedUniforms[ uniformName ] !== this.uniforms[ uniformName ].value) {
                          needChange = true
                        }
                      }
                      else if (currentBindedUniforms[ uniformName ].length) {
                        needChange = false
                        let array1 = this.uniforms[ uniformName ].value;
                        let array2 = currentBindedUniforms[ uniformName ];
                        if (array1.length !== array2.length) {
                          needChange = true
                        }
                        else {
                          for (var j = 0; j < array1.length; j++) {
                            if (array1[j] !== array2[j]) {
                              needChange = true
                              break
                            }
                          }
                        }
                      }
                      else {
                        needChange = true    
                      }
                      currentBindedUniforms[ uniformName ] = this.uniforms[ uniformName ].value
                  }
                  else {
                    needChange = true;
                  }
                }
                
                if (needChange) {
                  let v = this.uniforms[ uniformName ].value;
                  switch (type) {
                    case '2f':
                      this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1]);
                      break;
                    case '3f':  
                      this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1], v[2]);
                      break;
                    case '4f':
                      this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1], v[2], v[3]);
                      break;
                    default:
                      this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v);
                      break;
                  }
                }
              }
              break;
          }

      }
    }




    if (geometry.attributes['instanceMatrix']) {
      angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );
      
      if (  geometry.attributes['index'] ) {

        geometry.attributes['index'].bind()
        angle_instanced_array.drawElementsInstancedANGLE(
          this.type,
          geometry.attributes['index'].length,
          this.gl.UNSIGNED_SHORT,
          0,   // offset
          geometry.attributes['instanceMatrix'].length / geometry.attributes['instanceMatrix'].size  // num instances
        );
      }
      else {
        angle_instanced_array.drawArraysInstancedANGLE(
          this.type,
          0,                 // offset
          geometry.length,   // num vertices per instance
          geometry.attributes['instanceMatrix'].length / geometry.attributes['instanceMatrix'].size,  // num instances
        );
      }

    }
    else {
      if (  
          this.type !== this.gl.POINTS 
          && geometry.attributes['index'] 
        ) {
        geometry.attributes['index'].bind()
        this.gl.drawElements(this.wireframe ? this.gl.LINE_STRIP : this.type, geometry.attributes['index'].length, this.gl.UNSIGNED_SHORT, 0);
      }
      else {
        this.gl.drawArrays(this.wireframe ? this.gl.LINE_STRIP : this.type, 0, geometry.length);
      }
    }  





  }

  setUniform(name, value) {
    if (this.uniforms[name]) {
      this.uniforms[name].value = value
    }
  }

  setDefine(name, value) {
    if (value == null) {
      delete this.defines[ name ]
    }
    else {
      this.defines[ name ] = value
    }
  }


}


export default Program;